"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyMobileStepper = void 0;

const KeyboardArrowLeft_1 = __importDefault(require("@mui/icons-material/KeyboardArrowLeft"));

const KeyboardArrowRight_1 = __importDefault(require("@mui/icons-material/KeyboardArrowRight"));

const material_1 = require("@mui/material");

const react_1 = __importDefault(require("react"));

const buttonBaseStyle = {
  padding: "2px 5px",
  minWidth: "0"
};
const StyledMobileStepper = (0, material_1.styled)(material_1.MobileStepper, {
  shouldForwardProp: prop => prop !== 'stepsStyle'
})(({
  stepsStyle
}) => Object.assign({
  width: "fit-content",
  fontSize: "0.9rem",
  background: "transparent"
}, stepsStyle));
const StyledBackButton = (0, material_1.styled)(material_1.Button, {
  shouldForwardProp: prop => prop !== "backButtonText" && prop !== "backButtonStyle"
})(({
  backButtonText,
  backButtonStyle
}) => Object.assign(Object.assign(Object.assign({}, buttonBaseStyle), {
  marginRight: "10px",
  paddingRight: backButtonText ? "15px" : "5px"
}), backButtonStyle));
const StyledNextButton = (0, material_1.styled)(material_1.Button, {
  shouldForwardProp: prop => prop !== "nextButtonText" && prop !== "nextButtonStyle"
})(({
  nextButtonText,
  nextButtonStyle
}) => Object.assign(Object.assign(Object.assign({}, buttonBaseStyle), {
  marginLeft: "10px",
  paddingLeft: nextButtonText ? "15px" : "5px"
}), nextButtonStyle));

const SskyMobileStepper = props => {
  const {
    maxSteps,
    activeStep,
    handleNext,
    handleBack,
    nextButtonText,
    backButtonText,
    className,
    dataTestId
  } = props;
  return react_1.default.createElement(StyledMobileStepper, {
    steps: maxSteps,
    position: "static",
    variant: "text",
    activeStep: activeStep,
    className: className,
    "data-testid": dataTestId,
    nextButton: react_1.default.createElement(StyledNextButton, {
      onClick: handleNext,
      disabled: activeStep === maxSteps - 1,
      "data-testid": `${dataTestId}-button-next`,
      size: "small",
      nextButtonText: props.nextButtonText,
      nextButtonStyle: props.nextButtonStyle
    }, nextButtonText, react_1.default.createElement(KeyboardArrowRight_1.default, null)),
    backButton: react_1.default.createElement(StyledBackButton, {
      onClick: handleBack,
      disabled: activeStep === 0,
      "data-testid": `${dataTestId}-button-back`,
      size: "small",
      backButtonText: props.backButtonText,
      backButtonStyle: props.backButtonStyle
    }, react_1.default.createElement(KeyboardArrowLeft_1.default, null), backButtonText),
    stepsStyle: props.stepsStyle
  });
};

exports.SskyMobileStepper = SskyMobileStepper;
exports.default = react_1.default.memo(SskyMobileStepper);